import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { decimalFormatter } from 'Utils/decimalFormatter';
import { updateIsEyeOpenCheck } from 'Store/actions';
import LocalStorage from 'Utils/localStorage';

const withPrivacyEye = WrappedComponent => props => {
  const dispatch = useDispatch();
  const { data: authData, isEyeOpen } = useSelector(state => state.auth);
  const isDesktop = useSelector(state => state.userAgent?.device?.type === 'desktop');
  const [privacyState, setPrivacyState] = useState({
    icon: '',
    balance: '',
    balanceName: '',
    name: ''
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      dispatch(updateIsEyeOpenCheck(LocalStorage.get('eyeOpen') ?? true));
    }
  }, []);

  useEffect(() => {
    updateStates();
  }, [isEyeOpen, authData, isDesktop]);

  const updateStates = ()=>{
    if (authData?.balance || authData?.balance === 0) {
      const formattedBalance = decimalFormatter(authData.balance);

      const hideBalanceCharacter = authData.balance === 0 ? '**' : '*'.repeat(formattedBalance?.length + 2);

      const eyeColorClass = isDesktop ? 'bly-white' : 'bly-black-white';

      setPrivacyState({
        icon: `bly ${eyeColorClass} ${isEyeOpen ? 'bly-eye-dark-new' : 'bly-eye-hide-dark-new'}`,
        balanceName: isEyeOpen ? 'Bakiye' : '******',
        balance: isEyeOpen ? formattedBalance : hideBalanceCharacter,
        name: isEyeOpen ? authData?.name : '*'.repeat(authData?.name?.length),
      });
    }
  };

  return (
    <WrappedComponent
      privacy={ {
        ...privacyState,
        isEyeOpen,
        toggleEye: ()=>dispatch(updateIsEyeOpenCheck(!isEyeOpen)),
      } }
      { ...props }
    />
  );
};

export default withPrivacyEye;
